/* mcdwisco recruiting landing — hero rotator, scroll reveal, form pills.
   Ported from the design handoff. The form now submits natively to Shopify's
   contact endpoint (the prototype faked success client-side).
   The page is now assembled from independent theme sections, each of which loads
   this file; the guard below ensures the behaviors initialize exactly once. */
(function(){
  if (window.__mcdwInit) return;
  window.__mcdwInit = true;
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
  function init(){
    if (window.__mcdwRan) return;
    window.__mcdwRan = true;
    initForm(); initHero(); initReveal(); initClock(); initCast();
  }
})();
function initClock(){
  var els = document.querySelectorAll('.mcdw .topclock');
  if(!els.length) return;
  function render(){
    var locale = document.documentElement.getAttribute('lang') === 'es' ? 'es-US' : 'en-US';
    var now = new Date();
    var narrow = window.matchMedia && window.matchMedia('(max-width:640px)').matches;
    var txt = now.toLocaleDateString(locale, narrow ? {month:'short', day:'numeric'}
                                                    : {weekday:'short', month:'short', day:'numeric', year:'numeric'})
            + ' · ' + now.toLocaleTimeString(locale, {hour:'numeric', minute:'2-digit'});
    [].forEach.call(els, function(el){ if(el.textContent !== txt) el.textContent = txt; });
  }
  render();
  setInterval(render, 1000);
  window.mcdwRenderClock = render; /* let the language toggle refresh it instantly */
}
function initForm(){
  var form = document.getElementById('inqForm');
  if(!form) return;
  function wirePills(groupId, hiddenId){
    var group = document.getElementById(groupId);
    var hidden = document.getElementById(hiddenId);
    if(!group||!hidden) return;
    group.addEventListener('click', function(e){
      var b = e.target.closest('.pill'); if(!b) return;
      [].forEach.call(group.querySelectorAll('.pill'), function(p){ p.classList.remove('on'); p.setAttribute('aria-pressed','false'); });
      b.classList.add('on'); b.setAttribute('aria-pressed','true');
      hidden.value = b.getAttribute('data-v');
      var err = document.getElementById('roleErr'); if(err) err.style.display='none';
    });
  }
  wirePills('rolePills','rl');
  wirePills('expPills','exp');
  wirePills('locPills','loc');
  form.addEventListener('submit', function(e){
    var rl = document.getElementById('rl');
    var err = document.getElementById('roleErr');
    if(rl && !rl.value){ e.preventDefault(); if(err) err.style.display='block'; return; }
    if(!form.checkValidity()){ e.preventDefault(); form.reportValidity(); return; }
    /* valid — let the browser POST to Shopify's contact endpoint. On success
       Shopify reloads the page and Liquid renders the "Thanks" panel. */
  });
}
function initHero(){
  var FALLBACK=[
    {pill:'Where careers begin', w1:'Real', w2:'Opportunity.', sub:'We build careers, not just shifts, with room to rise at every restaurant.'},
    {pill:'Serving our community', w1:'Every', w2:'Family.', sub:'From first smiles to Friday nights, we show up for every family we serve.'},
    {pill:'Quality you can taste', w1:'Gold', w2:'Standard.', sub:'We set the standard, every single order, exactly the way it should be.'},
    {pill:'Made with care', w1:'Always', w2:'Fresh.', sub:'Real care at every station, every shift, made the way it should be.'},
    {pill:'A team that feels like family', w1:'One', w2:'Crew.', sub:'A crew that looks out for each other, where everyone truly belongs.'}
  ];
  var slides=FALLBACK;
  var data=document.getElementById('heroSlides');
  if(data){ try{ var parsed=JSON.parse(data.textContent); if(parsed&&parsed.length){ slides=parsed; } }catch(e){} }
  var hero=document.querySelector('.mcdw .hero'); if(!hero) return;
  var photos=[].slice.call(hero.querySelectorAll('.bgphoto'));
  var pill=document.getElementById('heroPill');
  var w1=document.getElementById('heroW1');
  var w2=document.getElementById('heroW2');
  var sub=document.getElementById('heroSub');
  var rot=document.getElementById('heroRot');
  var dots=[].slice.call(document.querySelectorAll('#heroDots .hdot'));
  if(photos.length<2||!w1||!w2||!sub||!rot) return;
  var i=0, timer=null, DUR=5200;
  function go(n){
    n=(n+slides.length)%slides.length;
    if(n===i) return;
    var s=slides[n];
    if(photos[i%photos.length]) photos[i%photos.length].classList.remove('on');
    if(photos[n%photos.length]) photos[n%photos.length].classList.add('on');
    rot.classList.add('swap');
    setTimeout(function(){
      if(pill) pill.textContent=s.pill;
      w1.textContent=s.w1; w2.textContent=s.w2; sub.textContent=s.sub;
      rot.classList.remove('swap');
    }, 360);
    dots.forEach(function(d,di){ d.classList.toggle('on', di===n); });
    i=n;
  }
  function next(){ go(i+1); }
  function start(){ timer=setInterval(next, DUR); }
  function reset(){ clearInterval(timer); start(); }
  dots.forEach(function(d,di){ d.addEventListener('click', function(){ go(di); reset(); }); });
  start();
}
function initReveal(){
  var els = [].slice.call(document.querySelectorAll('.mcdw .reveal'));
  function reveal(e){ e.classList.add('in'); }
  if(!('IntersectionObserver' in window)){ els.forEach(reveal); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ reveal(en.target); io.unobserve(en.target); } });
  }, {threshold:.12, rootMargin:'0px 0px -8% 0px'});
  els.forEach(function(e){ io.observe(e); });
  setTimeout(function(){ els.forEach(reveal); }, 1600);
  window.addEventListener('load', function(){ setTimeout(function(){ els.forEach(reveal); }, 400); });
}
/* Cast (2026-10): each box's characters climb on once, on arrival. Final pose is the CSS default; .cast-wait
   goes on only after observe(), only below the fold. Viewport root (.page-wrapper scrolls only from 990px). */
function initCast(){
  var st=[].slice.call(document.querySelectorAll('.mcdw .cast-stage'));
  if(!st.length||(window.Shopify&&Shopify.designMode)||(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)||!('IntersectionObserver' in window)) return;
  var io=new IntersectionObserver(function(es){ es.forEach(function(e){
    if(!e.isIntersecting) return; io.unobserve(e.target);
    [].forEach.call(e.target.querySelectorAll('.cast-wait'),function(k){ k.classList.remove('cast-wait'); });
  }); },{threshold:0,rootMargin:'0px 0px -18% 0px'});
  var vh=window.innerHeight||document.documentElement.clientHeight;
  st.forEach(function(s){
    var r=s.getBoundingClientRect(); if(r.top<vh*.82&&r.bottom>0) return;   /* on screen at load: no replay */
    io.observe(s);
    [].forEach.call(s.querySelectorAll('.cast'),function(k){ k.classList.add('cast-wait'); });
  });
}

/* Restaurant switcher on the exec command center. Both panels are already in the DOM;
   this only toggles which is shown. Falls back to Beaver Dam if markup is absent. */
(function () {
  function initStoreSwitch() {
    var wrap = document.querySelector('.storeswitch');
    if (!wrap) return;
    var pills = wrap.querySelectorAll('.ss-pill');
    var panels = document.querySelectorAll('[data-storepanel]');
    if (!pills.length || !panels.length) return;

    function show(key) {
      for (var i = 0; i < panels.length; i++) {
        panels[i].hidden = panels[i].getAttribute('data-storepanel') !== key;
      }
      for (var j = 0; j < pills.length; j++) {
        var on = pills[j].getAttribute('data-store') === key;
        pills[j].classList.toggle('is-on', on);
        pills[j].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      try { sessionStorage.setItem('mcdw-store', key); } catch (e) {}
    }

    for (var k = 0; k < pills.length; k++) {
      pills[k].addEventListener('click', function () {
        show(this.getAttribute('data-store'));
      });
    }
    // remember the choice for the session, so switching pages does not reset it
    var saved = null;
    try { saved = sessionStorage.getItem('mcdw-store'); } catch (e) {}
    if (saved) show(saved);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoreSwitch);
  } else { initStoreSwitch(); }
})();

/* Phone: charts collapse behind the key numbers. Desktop never sees the button, so the
   panels are left open there — the class is only ever added by a tap. */
(function () {
  function initDetailToggles() {
    var btns = document.querySelectorAll('[data-detail]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        var panel = this.nextElementSibling;
        if (!panel || !panel.classList.contains('paneldetail')) return;
        var open = panel.classList.toggle('is-open');
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.firstChild.nodeValue = open ? 'Hide the charts' : 'Show the charts';
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDetailToggles);
  } else { initDetailToggles(); }
})();
